<template>
  <b-row class="p-5" id="permission-info">
    <b-col>
      <b-row class="text-center pb-5">
        <b-col>
          <h1>System niedostępny</h1>
        </b-col>
      </b-row>
      <b-row
        v-if="contextSystemUnavailableEndDate"
        class="text-center pb-2"
      >
        <b-col> Do: {{ contextSystemUnavailableEndDate }} </b-col>
      </b-row>
      <b-row
        v-if="contextSystemUnavailableMessage"
        class="text-center pb-2"
      >
        <b-col>
          {{ contextSystemUnavailableMessage }}
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'system-unavailable-overlay'
}
</script>

<style scoped>
</style>
